<template>
    <div>
        <top-bar :leftLogo="true" :isShowSidebar="true" @onClickMembership="onClickCancelMembership()"></top-bar>

        <div class="profile-content pb-5" v-if="profileDior != null">
            <!-- <div v-if="profileDior.memberType != 'C'" class="level">
                <img v-if="profileDior.memberType == '12GC'" src="@/assets/img/03-profile/level-gold@2x.png"/>
                <img v-if="profileDior.memberType == '12E'" src="@/assets/img/03-profile/level-explorer@2x.png"/>
                <img v-if="profileDior.memberType == '12P'" src="@/assets/img/03-profile/level-platinum@2x.png"/>
            </div> -->
            <div class="page-header">
                <div class="border-left-header"></div>
                <div class="name-header">{{lbl.profile.title}}</div>
                <div class="btn-edit" @click="editProfile()">{{lbl.profile.edit}}</div>
            </div>
            <div class="profile-info">
                <div class="first-name ellipsis">{{profileDior.memberName}}</div>
                <!-- <div class="first-name"><span class="pr-2">{{prefix}}</span>{{txt.firstname}}</div> -->
                <!-- <div class="last-name">{{txt.lastname}}</div> -->
                <div class="profile-card-wrapper">
                    <ProfileCard :lbl="lbl" :profileDior="profileDior" :point="point"></ProfileCard>
                </div>
                <div class="desc-wrapper">
                    <div class="desc-info">
                        <div class="icon-info-wrapper">
                            <img class="icon-info birthday" src="@/assets/img/03-profile/ic-birthdaynew.svg"/>
                        </div>
                        <div class="text-desc birthday">{{txt.birthdate}}</div>
                    </div>
                    <div class="desc-info">
                        <div class="icon-info-wrapper">
                            <img class="icon-info phone" src="@/assets/img/03-profile/ic-phonenew.svg"/>
                        </div>
                        <div class="text-desc">{{profileDior.mobileNumber | phone_format}}</div>
                    </div>
                    <div class="desc-info">
                        <div class="icon-info-wrapper">
                            <img class="icon-info email" src="@/assets/img/03-profile/ic-emailnew.svg"/>
                        </div>
                        <div class="text-desc">{{profileDior.email}}</div>
                    </div>
                    <div class="desc-info">
                        <div class="icon-info-wrapper">
                            <img class="icon-info address" src="@/assets/img/03-profile/ic-addressnew.svg"/>
                        </div>
                        <div class="text-desc">{{profileDior.address}} {{profileDior.subDistrict}} {{profileDior.district}} {{profileDior.province}} {{profileDior.zipcode}}</div>
                    </div>
                    <div class="desc-info">
                        <div class="icon-info-wrapper">
                            <img class="icon-info" src="@/assets/img/03-profile/ic-language@3x.png"/>
                        </div>
                        <div class="lang-wrapper">
                            <div class="lang" :class="{ active: localeCode == 1033 }" @click="switchLang(1033)">ENG</div>
                            <div class="lang" :class="{ active: localeCode == 1054 }" @click="switchLang(1054)">ไทย</div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <menu-bar :currentTab="currentPage"></menu-bar>
        <modal view="register-main" :busModal="busModal" :isShowLogo="true"></modal>
    </div>
</template>

<script>
import Vue from "vue";
import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
import TopBar from "@/components/TopBar.vue";
// import VueBarcode from '@chenfengyuan/vue-barcode'; // https://github.com/fengyuanchen/vue-barcode/blob/master/README.md
import MenuBar from "@/components/MenuBar.vue";
import Modal from "@/components/modal/Modal.vue";
import DiorApi from "@/service/dior/DiorApi.js";
import LineFunction from '@/helper/facade/LineFunction.js';
import { TrackingService } from "@/helper/TrackingHelper";
import ProfileCard from './module/Profile/ProfileCard.vue'
// import { DiorPorfileModel } from "@/model/Dior/DiorProfileModel.js"

export default {
    name: "Profile",
    components: {
        TopBar,
        // VueBarcode,
        MenuBar,
        Modal,
        ProfileCard,
    },
    data: function() {
        return {
            currentPage:"profile",
            isLogin: false,
            profile: {},
            profileDior: null,
            lbl: Locale.getLbl(),
            localeCode: Locale.getLocaleCode(),
            mycode: "1234567891",
            prefix: "",

            objBarcodeConfig: {
                width: 1,
                height: 50,
                margin: 0,
                displayValue: true,
                background: '#eeeeee',
                fontSize: 15
            },

            txt: {
                firstname: '',
                lastname: '',
                birthdate: '',
            },
            busModal: new Vue(),
            point: "",
            tracking: new TrackingService(this),
        };
    },
    created: function() {
        console.log("profile");
        Account.loginStatus().then((status) => {
            this.isLogin = status;
            this.showLoading();
            Account.apiGetProfileDior().then((res) => {
                var user = Account.getCacheUser();
                user.userLevel = res.data.BzbUserLevel;
                Account.setCacheUser(user);

                this.profile = Account.getCacheProfile();
                this.profileDior = Account.getCacheDiorProfile();
                this.setText();
                Util.log(this.profileDior);
                this.hideLoading();
                this.callApiGetPoint();
            })
            .catch(() => {
                this.$router.push("/register");
                this.hideLoading();
            });
        });
        this.tracking.screenName('Profile');
    },
     mounted: function() {
          this.checkIsAlreadyRegister((result) => {
            if (result) {
                // go profile

            } else {
                // this.$router.push('/profile');
                this.$router.push('/register');
            }
        });

    },
    methods: {

        switchLang: function(locale) {
            this.showLoading();
            Account.apiUpdateProfileLocale(locale)
                .then(profile => {
                    this.hideLoading();
                    if (profile)
                        this.profile = profile;

                    Locale.setLocale(locale);
                    this.lbl = Locale.getLbl();
                    this.localeCode = Locale.getLocaleCode();
                    // this.setupDropdownAfterLocaleChange();
                    this.getPrefix();
                    this.$nextTick(() => {
                        window.location.reload()
                    });
                })
                .catch(() => {

                    this.hideLoading();
                });
        },
        editProfile: function() {
            this.$router.push("/editprofile");
            this.tracking.event('Edit_Profile', 'click_edit_profile');
        },
        setText: function() {

            if (!this.profileDior.memberName
                || !this.profileDior.mobileNumber
                || !this.profileDior.birthDay
                || !this.profileDior.birthMonth
                || !this.profileDior.birthYear) {
                 this.showErrorConnectModal(this.lbl.error_empty.message);
            }


            // var name = this.profileDior.memberName.split(' ');
            // this.txt.firstname = name[0];
            // this.txt.lastname = name[1];
            var day = this.profileDior.birthDay;
            var month = this.profileDior.birthMonth;
            var year = this.profileDior.birthYear;
            month = month.length == 1 ? '0' + month : month;
            day = day.length == 1 ? '0' + day : day;
            this.txt.birthdate = day + '-' + month + '-' + year;
            this.getPrefix();
        },
        getPrefix: function () {
            if (this.profileDior.prefix == "MS") {
                this.prefix = this.lbl.editprofile.ms;
            }
            if (this.profileDior.prefix == "MRS") {
                this.prefix = this.lbl.editprofile.mrs;
            }
            if (this.profileDior.prefix == "MR") {
                this.prefix = this.lbl.editprofile.mr;
            }
        },
        initLiff: function() {
            return new Promise((resolve) => {
                var lineFunction = new LineFunction();
                this.liffId = lineFunction.getLiffId();

                lineFunction.init(this.liffId).then(() => {

                    this.lineIdToken = lineFunction.getIdToken();
                    resolve();
                }).catch((err) => {
                    console.log(err);
                    // this.setNotLineRegister();
                    // this.$router.replace('/error');
                });
            });

        },
        checkIsAlreadyRegister: async function(callback) {
            await this.initLiff();
            var token = Account.getToken();
            //var lineUserId = Account.getLineUserId();
            this.showLoading();
            DiorApi.isUserRegistered(token, this.lineIdToken).then((res) => {
                this.hideLoading();
                console.log(res.data);
                var isMember = (res.data) ? res.data.IsMember : false;
                if (typeof callback == 'function') {
                    callback(isMember);
                }
            }).catch((err) => {
                this.hideLoading();
                if (err.response) {
                    console.log(err.response.data);
                } else {
                    console.log(err);
                    this.showErrorConnectModal();
                }

                if (typeof callback == 'function') {
                    callback(false);
                }
            });
        },
        callApiGetPoint: function () {

            Account.apiGetPoint().then((result) => {

                this.point = result.points;
                console.log("this.point", this.point)
            }).catch ((err) => {
                console.log(err);
                 if (err.response) {
                    console.log(err.response.data);
                } else {
                    console.log(err);
                    this.showErrorConnectModal();
                }
            }) ;
        },
        showLoading: function() {
            this.busModal.$emit('showLoadingModal', {});
        },
        hideLoading: function() {
            this.busModal.$emit('hideLoadingModal', {});
        },
        showErrorConnectModal: function(message) {

            var configModal = {

                message: message? message : this.lbl.error_connect.messag,
                strBtnOk: this.lbl.error_connect.btn_close,
            };
            this.busModal.$emit('showErrorConnectModal', configModal);
        },
        onClickCancelMembership: function(){
            const message = this.lbl.cancel_membership.message
            const phone = this.lbl.cancel_membership.phone
            const email = this.lbl.cancel_membership.email
            const content = '<div style="padding-bottom:20px; font-weight:bold; text-transform: uppercase">'+ message +'</div>' +
                            '<div style="padding-bottom:5px;">'+ phone +'</div>' +
                            '<div>'+ email +'</div>'
            let configModal = {
                message: content,
                strBtnOk: this.lbl.error_connect.btn_close,
            };
            this.busModal.$emit('showErrorConnectModal', configModal);
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/page/profile.scss";
    .alert-logo{
        margin: 60px 0 60px 0;
    }
</style>
